export type LiveStatus = 'idle' | 'connecting' | 'live' | 'reconnecting' | 'error'

interface StatusConfig {
  dot: string
  label: string
  labelColor: string
  pulse: boolean
}

const STATUS_CONFIG: Record<'connecting' | 'live' | 'reconnecting', StatusConfig> = {
  connecting: { dot: 'bg-gray-400', label: 'Connecting...', labelColor: 'text-gray-400', pulse: false },
  live: { dot: 'bg-green-500', label: 'Live', labelColor: 'text-green-700', pulse: true },
  reconnecting: { dot: 'bg-amber-400', label: 'Reconnecting...', labelColor: 'text-amber-600', pulse: false },
}

export function LiveIndicator({ status }: { status: LiveStatus }): JSX.Element | null {
  if (status === 'idle' || status === 'error') return null
  const config = STATUS_CONFIG[status]
  return (
    <div className="flex items-center gap-1.5">
      <span className="relative flex h-2 w-2">
        {config.pulse && (
          <span className={`absolute inline-flex h-full w-full animate-ping rounded-full ${config.dot} opacity-60`} />
        )}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${config.dot}`} />
      </span>
      <span className={`text-[13px] ${config.labelColor}`}>{config.label}</span>
    </div>
  )
}
